import styled from 'styled-components'
import { useTransition, animated } from '@react-spring/web'

export const LabelGizmo = ({
  label,
  show,
  position
}: {
  label: any
  show?: boolean
  position?: string
}) => {
  const transition = useTransition(show, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 1000 },
  })

  const scaleX = position?.includes('right') ? -1 : 1
  const scaleY = position?.includes('top') ? -1 : 1
  const translateX = position?.includes('right') ? 0 : 0
  const translateY = position?.includes('top') ? 22 : 0

  return (
    <>
      {transition(
        (style, item) =>
          item && (
            <animated.div
              style={{
                opacity: style.opacity,
                fontFamily: 'var(--font-sans-serif)',
                fontWeight: 400,
                lineHeight: 1.2,
                fontSize: '0.85em',
                color: 'var(--brandblue-main)',
                background: 'var(--yellow-main)',
                width: 'auto',
                whiteSpace: 'nowrap',
                padding: '0.2em 0.5em',
                borderRadius: '0.2em',
                transformOrigin: 'center center',
                textAlign: position?.includes('right') ? 'right' : 'left',
                transform: position?.includes('right') ? 'translateX(-100%)' : 'translateX(20px)',
                translateY: (position?.includes('top') ? '0' : '-100%'),
                fontSmooth: 'antialiased'
              }}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='30'
                height='43'
                viewBox='0 0 22.8 18.2'
                style={{
                  position: 'absolute',
                  top: '11px',
                  left: position?.includes('right') ? 'auto' : '-30px',
                  right: position?.includes('right') ? '-30px' : 'auto',
                  transform: `scale(${scaleX}, ${scaleY}) translate(${translateX}px, ${translateY}px)`
                }}
              >
                <path
                  style={{ fill: 'none', stroke: 'var(--text-color)' }}
                  d='m22.8,0C5.3-.2,3.5,14.4,2.3,18.2'
                />
                <polyline
                  style={{ fill: 'none', stroke: 'var(--text-color)' }}
                  points='7.5 16 2.1 18.2 0 12.9'
                />
              </svg>
              {label}
            </animated.div>
          )
      )}
    </>
  )
}

const ArrowPath = styled.path<{ color: string }>`
  stroke: ${({ color }) => color};
  stroke-width: 1;
  fill: none;
`
const ArrrowHead = styled.polyline<{ color: string }>`
  stroke: ${({ color }) => color};
  stroke-width: 1;
  fill: none;
`

const CanvasLabel = styled.div<{ color: string }>``

const FigureLabel = styled.span`
  font-family: var(--chart-font-stack);
  color: var(--background-color);
  font-weight: 800;
  line-height: 1.2;
  font-size: 1em;
`
